'use client'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { useCallback } from 'react'
import viLocale from '@fullcalendar/core/locales/vi'
import {ScheduleType} from "models/model";
import {getEventColor, getTypeLabel} from "lib/utils";

interface MinaSchedulerProps {
    events: any[]
    onEventClick?: (event: any) => void
    [key: string]: any
}


export default function MinaScheduler({ events, onEventClick, ...props }: MinaSchedulerProps) {
    const handleEventClick = useCallback((info: any) => {
        if (onEventClick) {
            onEventClick(info.event)
        }
    }, [onEventClick])

    return (
        <div className="mina-scheduler-container h-full">
            <FullCalendar
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                events={events}
                headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                }}
                locale={viLocale}
                firstDay={1}
                buttonText={{
                    today: 'Hôm nay',
                    month: 'Tháng',
                    week: 'Tuần',
                    day: 'Ngày',
                    list: 'Danh sách'
                }}
                dayHeaderFormat={{ weekday: 'long' }}
                titleFormat={{ year: 'numeric', month: 'long' }}
                height="auto"
                contentHeight="auto"
                aspectRatio={1.2} // Giảm tỷ lệ để tăng chiều cao
                dayMaxEventRows={4} // Tăng số dòng tối đa
                dayCellContent={(arg) => {
                    return (
                        <div className="flex justify-center items-center h-full">
                            <span className="text-sm font-medium">{arg.dayNumberText}</span>
                        </div>
                    )
                }}
                eventContent={(eventInfo) => {
                    const type = eventInfo.event.extendedProps?.type || ScheduleType.LyThuyet
                    const teacherName = eventInfo.event.extendedProps?.teacherName
                    const plateNumber = eventInfo.event.extendedProps?.vehiclePlateName

                    const eventColor = getEventColor(type)
                    const typeLabel = getTypeLabel(type)

                    return (
                        <div className={`w-full h-full p-2 cursor-pointer ${eventColor} hover:bg-opacity-80 transition-all flex flex-col gap-1`}>
                            <div className="font-semibold text-sm mb-1 truncate">{typeLabel}</div>
                            <div className="text-xs">
                                <span className="font-medium font-bold">GV:</span> {teacherName || 'Không có'}
                            </div>
                            <div className="text-xs">
                                <span className="font-medium font-bold">Xe:</span> {plateNumber || 'Không có'}
                            </div>
                        </div>
                    )
                }}
                eventDidMount={(info) => {
                    const type = info.event.extendedProps?.type || ScheduleType.LyThuyet
                    const eventColor = getEventColor(type)

                    // Thiết lập style cho event element
                    info.el.style.width = 'calc(100% - 4px)'
                    info.el.style.margin = '2px'
                    info.el.style.border = 'none'
                    info.el.style.boxShadow = 'none'
                    info.el.style.borderRadius = '6px'
                    info.el.style.padding = '0'
                    info.el.style.height = 'calc(100% - 4px)'
                    info.el.style.display = 'flex'
                    info.el.style.flexDirection = 'column'
                    info.el.style.justifyContent = 'center'
                    info.el.style.minHeight = '80px' // Tăng chiều cao tối thiểu

                    // Thêm class màu
                    info.el.classList.add(...eventColor.split(' '))

                    // Đảm bảo event chiếm full chiều cao của ô
                    const dayGrid = info.el.closest('.fc-daygrid-day-frame')
                    if (dayGrid) {
                        // @ts-ignore
                        dayGrid.style.display = 'flex'
                        // @ts-ignore
                        dayGrid.style.flexDirection = 'column'
                        // @ts-ignore
                        dayGrid.style.minHeight = '100px' // Tăng chiều cao ô lịch
                    }
                }}
                eventClick={handleEventClick}
                {...props}
            />
        </div>
    )
}